// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3802a06d","501":"407398e9","735":"09804db2"}[chunkId] + ".chunk.js";
};